const QUANTIFIED_TARGET_PATTERN =
  /\b\d+(?:\.\d+)?\s*%|\b(?:reduce|decrease|cut|lower|improve|increase|raise|drop)\b[^.]{0,60}\b\d+(?:\.\d+)?/i;

const BASELINE_NUMERIC_PATTERN =
  /\b\d+(?:\.\d+)?\s*(?:%|percent|ppm|days?|hours?|minutes?|seconds?|secs?|weeks?|months?|years?|units?|orders?|cases?|claims?|errors?|defects?|complaints?|tickets?|ms|mins?)\b|\$\s*\d[\d,]*(?:\.\d+)?/i;

const VALIDATED_BASELINE_PATTERN =
  /\b(?:validated|measured|baseline|confirmed|current average|current rate|actual performance|observed)\b/i;

export function desiredStateHasQuantifiedTarget(desiredState) {
  return QUANTIFIED_TARGET_PATTERN.test(desiredState || "");
}

export function currentStateHasBaselineEvidence(currentState) {
  const value = currentState || "";
  return BASELINE_NUMERIC_PATTERN.test(value) || VALIDATED_BASELINE_PATTERN.test(value);
}

export function getDesiredStateWarning(problemStatement) {
  if (!desiredStateHasQuantifiedTarget(problemStatement?.desired_state)) {
    return null;
  }

  if (currentStateHasBaselineEvidence(problemStatement?.current_state)) {
    return null;
  }

  return {
    severity: "warning",
    message:
      "This objective includes a quantified target, but the current condition does not show a validated baseline yet. In Define, prefer improvement intent first and finalize the target after Measure confirms baseline performance.",
  };
}

export function validateProblemStatement(problemStatement) {
  const errors = {};

  if (!problemStatement?.impact?.trim()) {
    errors.impact =
      "Business Impact is required. Describe the consequence in business terms such as scrap cost, rework cost, throughput instability, delivery risk, or customer impact.";
  }

  return errors;
}
